import moment from 'moment';

export function getElapsedTime(date: Date): string {
  return moment(date).startOf('hour').fromNow();
}
